export default __webpack_public_path__ + "dd662d223b9a9e0b29829ef35c6e0dfe.png";